/*global Vue, _ */
import axios from 'axios'

export const init = (customAxios) => {
  customAxios = customAxios || axios
  const headers = {
    'X-Requested-With': 'XMLHttpRequest'
  }

  const csrfTokenElement = document.head.querySelector('meta[name="csrf-token"]');
  const csrf = csrfTokenElement && csrfTokenElement.content || ''
  if (csrf) {
    headers['X-CSRF-TOKEN'] = csrf
  }

  const authTokenElement = document.head.querySelector('meta[name="auth-token"]');
  const authToken = authTokenElement && authTokenElement.content || '';
  if (authToken) {
    headers['X-Authorization'] = 'Bearer ' + authToken
  }

  setHeaders(headers, customAxios)

  return {
    axios: customAxios,
    authToken,
    csrf,
    headers,
  }
}

export const setHeaders = (headers, customAxios) => {
   customAxios = customAxios || axios
  _.forOwn(headers, (value, key) => {
    customAxios.defaults.headers.common[key] = value
  })
}

export default {initAxios: init, setHeaders}
